import { useCallback, useState } from 'react';

import ProtocolService from '../../../../service';

export const useDefaultFieldsObject = (
  prevRecordTypeId,
  selectedRecordType
) => {
  const [fieldsObject, setFieldsObject] = useState({});

  const fetchFieldsObject = useCallback(async () => {
    if (!selectedRecordType) return;

    try {
      const response = await ProtocolService.getCompareDefaultFieldsObject(
        prevRecordTypeId,
        selectedRecordType
      );

      const fields = response.data.data;
      const { reason_id = {}, subreason_id = {}, current_status = {} } = fields;

      setFieldsObject({ reason_id, subreason_id, current_status });
    } catch (err) {
      console.error('Erro ao buscar campos customizados:', err);
      setFieldsObject({});
    }
  }, [prevRecordTypeId, selectedRecordType]);

  return { fieldsObject, fetchFieldsObject };
};
